




import { Vue, Component, Prop } from 'vue-property-decorator'
import { Route } from 'vue-router'
import store from '@/store'

@Component({
  components: {
    HdView: () => import('@/components/hdTab/HdView.vue')
  }
})
export default class HdIndex extends Vue {
  @Prop(Number) patientId!: number

  async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (payload?: { name: string }) => void
  ) {
    const patientId = Number(to.params.patientId)
    await store.dispatch('hd/fetchLatestHd', { patientId })
    if (!store.getters['hd/hd']) {
      next({ name: 'HdTabSetting' })
    } else {
      next()
    }
  }
}
